

















































































































































































































































































































































































































































































































































































































































































































































































































import axios from "axios";
import "bootstrap-vue";
import Vue from "vue";
import Component from "vue-class-component";
import Multiselect from "vue-multiselect";
import CabinetHeader from "./CabinetHeader.vue";
import VueElementLoading from "vue-element-loading";
import store from "@/services/store";
import {
    IGu,
    IKato,
    IKgkp,
    IModule,
} from "../user-management/user-management-int";
import AdminSample from "./admin-sample.vue";
import AccessRequest from "./access-request.vue";

export interface IUsers {
    id: string | null;
    iin: string;
    firstname: string;
    lastname: string;
    patronymic?: string | null;
    fullName?: string;
    phone?: string;
    email?: string | null;
    cntGu?: number;
    cntKgkp?: number;
    check: boolean;
    isAggregate?: boolean;
    isExpDropdown?: boolean;
}
export interface IWorkPlace {
    code: string;
    bin?: string;
    name_ru?: string;
    name_kk?: string;
    text: string;
    type: "GU" | "KGKP";
}

export interface INewUsers {
    iin: string;
    firstName: string;
    lastName: string;
    middleName?: string;
    phone: string;
    email?: string;
    gu?: string;
    isAdductor: boolean;
    modules: IBaseModule[];
    hiddenModules?: IBaseModule[];
    isExpDropdown: boolean;
}
export interface IBaseModule extends IModule {
    isModuleDrown?: boolean; // Флаг раскрытия родительского модуля всех модулей
    isUsersModuleDrown?: boolean; // Флаг раскрытия доступных дочерних модулей
    canAgree: boolean;
    canEdit: boolean;
    children: any;
    accessLevel?: number;
}

@Component({
    name: "administartion",
    components: {
        multiselect: Multiselect,
        CabinetHeader,
        loading: VueElementLoading,
        AdminSample,
        AccessRequest,
    },
})
export default class Administration extends Vue {
    $refs!: {
        drop: HTMLFormElement;
        userCardRef: HTMLFormElement;
        reqFormRef: HTMLFormElement;
        bcRegGu: HTMLFormElement;
        bcRegion: HTMLFormElement;
        bcRegionKgkp: HTMLFormElement;
        bcGu: HTMLFormElement;
        bcGkkp: HTMLFormElement;
        fileInput: HTMLFormElement;
    };
    private curTab = 0;
    private showUserCard = false;
    private showRequestForm = false;
    private loading: boolean = false;
    private oblKato: any = null;
    private regionList: IKato[] = [];
    private typeOrg: number = 0;
    private guList: IGu[] = [];
    private gkkpList: IKgkp[] = [];
    private selectedRegion: any = null;
    private selectedRegGu: any = null;
    private selectedRegionKgkp: any = null;
    private selectedRegKgkp: any = null;
    private selectedGu: any = null;
    private selectedGkkp: any = null;
    private selectedKgkpGu: any = null;
    private usersList: IUsers[] = [];
    private selectAllFiltered: boolean = false;
    private searchIIN: string = "";
    private searchName: string = "";
    private searchPhone: string = "";
    private searchEmail: string = "";
    private backUsersList = true;
    private selectedUser: IUsers | null = null;
    private selWorkPlace: any = null;
    private workPlaceList: IWorkPlace[] = [];
    private hasWorkPlace: boolean = false;
    private workPlaceTypes: "GU" | "KGKP" | "Both" | null = null;
    private workPlaceGu: any[] = [];
    private workPlaceKgkp: any[] = [];
    private budgetLevelList: any[] = [];
    private selBudgetLevel: any = null;
    private modulesList: IBaseModule[] = [];
    private modulesBase: IBaseModule[] = [];
    private supportStatus: boolean | null = null;
    private selectedRequest: any = null;
    private backReqList = true;
    private vidReqList: any[] = [];
    private selectedReqVid: any = null;
    private typeReqList: any[] = [];
    private selectedReqType: any = null;
    private currentUser: IUsers | null = null;
    private curUserFullname: string = "";
    private curUserEmail: string = "";
    private file: any = null as File | null;
    private newUserList: INewUsers[] = [];

    get reqDate() {
        const currentDate: Date = new Date();
        return currentDate.toISOString().split("T")[0];
    }

    get numberReq() {
        const number = "1";
        return number;
    }

    get statusReq() {
        const status = "Новая";
        return status;
    }

    get userId() {
        return store.getters.user_uuid;
    }

    get isUserSupport() {
        return this.supportStatus;
    }

    get hasAccessUsersTab(): boolean {
        const moduleCode = "100.000.004.001";
        const accessLevel = this.$store.state.user.userModules.find(
            (it: any) => it.modules === moduleCode
        );
        return !!accessLevel;
    }

    get hasAccessRequestTab(): boolean {
        const moduleCode = "100.000.004.002";
        const accessLevel = this.$store.state.user.userModules.find(
            (it: any) => it.modules === moduleCode
        );
        return !!accessLevel;
    }

    get hasAccessTempTab(): boolean {
        const moduleCode = "100.000.004.003";
        const accessLevel = this.$store.state.user.userModules.find(
            (it: any) => it.modules === moduleCode
        );
        return !!accessLevel;
    }

    get accessRequestTabIndex(): number {
        return this.hasAccessUsersTab ? 1 : 0;
    }

    public created() {
        this.$watch("typeOrg", (newValue) => {
            if (newValue === 0) {
                this.getUserGuWork();
            } else {
                this.getUserKgkpWork();
            }
        });

        // Наблюдатель за изменением selectedRegion
        this.$watch("selectedRegion", (newValue) => {
            if (newValue && newValue.code) {
                this.fetchGuListForRegion(newValue.code);
            } else {
                this.guList = [];
            }
        });

        // Наблюдатель за изменением selectedRegionKgkp
        this.$watch("selectedRegionKgkp", (newValue) => {
            if (newValue && newValue.code) {
                this.fetchKgkpListForRegion(newValue.code);
            } else {
                this.gkkpList = [];
            }
        });

        // Наблюдатель за изменением selectedGu
        this.$watch("selectedGu", (newValue) => {
            if (newValue && newValue.region) {
                this.selectedRegGu = newValue.region;
            } else {
                this.selectedRegGu;
            }
        });

        // Наблюдатель за изменением selectedGkkp
        this.$watch("selectedGkkp", (newValue) => {
            if (newValue) {
                this.fetchGuForKgkp(newValue.code);
                this.selectedRegKgkp = newValue.region;
            } else {
                this.selectedKgkpGu = "Нет данных";
                this.selectedRegKgkp = null;
            }
        });

        this.$watch("backUsersList", (newValue) => {
            if (newValue) {
                this.showUserCard = false;
            }
        });
    }

    public async mounted() {
        // await this.loadReceiversList();
        await this.fetchUserSupportStatus();
        const result = await this.loadAllWorkPlaces();
    }

    async fetchUserSupportStatus() {
        try {
            const res = await fetch(`/api/um/user-support/${this.userId}`);
            const data = await res.json();

            this.supportStatus = data[0] ?? false;
        } catch (error) {
            console.error("Ошибка при получении данных: ", error);
            this.supportStatus = false;
        }
    }

    // filtering workplace
    private async getUserGuWork() {
        try {
            const response = await fetch("/api/um/user-gu-list");
            const guData = await response.json();

            if (guData && guData.length > 0) {
                const regionResponse = await fetch("/api/um/user-region-list");
                const regionData = await regionResponse.json();
                const regionMap = regionData.reduce((acc: any, region: any) => {
                    acc[region.code] = region;
                    return acc;
                }, {});

                // Формир. список ГУ с привязкой к региону
                this.guList = guData.map((item: any) => {
                    const region = regionMap[item.regionCode];
                    return {
                        text: `${item.code} - ${item.nameRu}`,
                        code: item.code,
                        region: region
                            ? `${item.regionCode} - ${region.nameRu}`
                            : "Неизвестный регион",
                    };
                });

                if (this.guList.length > 0) {
                    this.selectedGu = this.guList[0];
                    this.selectedRegGu = this.selectedGu.region;
                } else {
                    this.selectedGu = null;
                    this.selectedRegGu = null;
                }
            } else {
                const regionResponse = await fetch("/api/um/user-region-list");
                const regionData = await regionResponse.json();
                const requests = regionData.map((item: any) => {
                    return {
                        text: `${item.code} - ${item.nameRu}`,
                        code: item.code,
                    };
                });
                this.regionList = await Promise.all(requests);
                if (this.regionList.length > 0) {
                    this.selectedRegion = this.regionList[0];
                    const response = await fetch(
                        `/api/um/user-gu-list?region=${this.selectedRegion.code}`
                    );
                    const data = await response.json();

                    this.guList = data.map((item: any) => {
                        return {
                            text: `${item.code} - ${item.nameRu}`,
                            code: item.code,
                        };
                    });

                    if (this.guList.length > 0) {
                        this.selectedGu = this.guList[0];
                    } else {
                        this.selectedGu = null;
                    }
                } else {
                    this.selectedRegion = null;
                }
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки место работы для: " + this.userId,
                    error.toString()
                );
            }
        }
    }

    // filtering region

    async fetchGuListForRegion(regionCode: any) {
        try {
            const response = await fetch(
                `/api/um/user-gu-list?region=${regionCode}`
            );
            const data = await response.json();

            this.guList = data.map((item: any) => ({
                text: `${item.code} - ${item.nameRu}`,
                code: item.code,
            }));

            if (this.guList.length > 0) {
                this.selectedGu = this.guList[0];
            } else {
                this.selectedGu = null;
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки список ГУ для региона: " + regionCode,
                    error.toString()
                );
            }
        }
    }

    // fetchKgkpListForRegion

    async fetchKgkpListForRegion(regionCode: any) {
        try {
            const response = await fetch(
                `/api/um/user-kgkp-list?region=${regionCode}`
            );
            const data = await response.json();

            this.gkkpList = await Promise.all(
                data.map(async (item: any) => ({
                    text: `${item.code} - ${item.nameRu}`,
                    code: item.code,
                }))
            );

            if (this.gkkpList.length > 0) {
                this.selectedGkkp = this.gkkpList[0];
            } else {
                this.selectedGkkp = null;
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки ГКГП для региона: " + regionCode,
                    error.toString()
                );
            }
        }
    }

    async fetchGuForKgkp(kgkpCode: string) {
        try {
            const kgkpDataResponse = await fetch(
                `/api-py/dict-kgkp-by-code/${kgkpCode}`
            );
            const kgkpDataArray = await kgkpDataResponse.json();
            const kgkpDataItem = kgkpDataArray.find(
                (kgkp: IKgkp) => kgkp.bin === kgkpCode
            );

            let guName = "";
            if (kgkpDataItem && kgkpDataItem.code_gu) {
                guName = await this.getGuName(kgkpDataItem.code_gu);
            }

            this.selectedKgkpGu = `${kgkpDataItem.code_gu}-${guName};`;
        } catch (error) {
            console.error("Ошибка получения данных ГУ:", error);
            this.selectedKgkpGu = "Ошибка получения данных ГУ";
        }
    }

    async getGuName(guCode: string) {
        try {
            const resGu = await fetch(`/api-py/dict-gu-by-code/${guCode}`);
            const guDataArray = await resGu.json();
            const guData = guDataArray.find((gu: any) => gu.code === guCode);
            return guData ? guData.name_ru : "ГУ не найдено";
        } catch (error) {
            console.error("Ошибка получения данных ГУ:", error);
            return "Ошибка получения данных ГУ";
        }
    }

    async getUserKgkpWork() {
        try {
            // Получение данных ГККП
            const responseGkkp = await fetch("/api/um/user-kgkp-list");
            const gkkpData = await responseGkkp.json();

            // Получение данных регионов
            const responseReg = await fetch("/api/um/user-region-list");
            const regions = await responseReg.json();
            const regionMap = regions.reduce((map: any, region: any) => {
                map[region.code] = region.nameRu;
                return map;
            }, {});

            if (gkkpData && gkkpData.length > 0) {
                this.gkkpList = gkkpData
                    .filter((item: any) => item.nameRu && item.code)
                    .map((item: any) => ({
                        text: `${item.code} - ${item.nameRu}`,
                        code: item.code,
                        region: item.regionCode
                            ? `${item.regionCode} - ${
                                  regionMap[item.regionCode] ||
                                  "Регион не указан"
                              }`
                            : "Регион не указан",
                    }));

                if (this.gkkpList.length > 0) {
                    this.selectedGkkp = this.gkkpList[0];
                    this.selectedRegKgkp = this.selectedGkkp.region;

                    // Получаем ГУ для выбранного ГККП
                    const kgkpDataResponse = await fetch(
                        `/api-py/dict-kgkp-by-code/${this.selectedGkkp.code}`
                    );
                    const kgkpDataArray = await kgkpDataResponse.json();
                    const kgkpDataItem = kgkpDataArray.find(
                        (kgkp: IKgkp) => kgkp.bin === this.selectedGkkp.code
                    );

                    let guName = "";
                    if (kgkpDataItem && kgkpDataItem.code_gu) {
                        guName = await this.getGuName(kgkpDataItem.code_gu);
                    }
                    this.selectedKgkpGu = `${kgkpDataItem.code_gu} - ${guName}`;
                } else {
                    this.selectedGkkp = null;
                    this.selectedRegKgkp = null;
                    this.selectedKgkpGu = null;
                }
            } else {
                const regionResponse = await fetch("/api/um/user-region-list");
                const regionData = await regionResponse.json();
                const requests = regionData.map((item: any) => {
                    return {
                        text: `${item.code} - ${item.nameRu}`,
                        code: item.code,
                    };
                });
                this.regionList = await Promise.all(requests);

                if (this.regionList.length > 0) {
                    this.selectedRegionKgkp = this.regionList[0];
                    const response = await fetch(
                        `/api/um/user-kgkp-list?region=${this.selectedRegionKgkp.code}`
                    );
                    const data = await response.json();

                    this.gkkpList = data.map((gkkp: any) => {
                        return {
                            text: `${gkkp.code} - ${gkkp.nameRu}`,
                            code: gkkp.code,
                        };
                    });

                    if (this.gkkpList.length > 0) {
                        this.selectedGkkp = this.gkkpList[0];
                    } else {
                        this.selectedGkkp = null;
                    }

                    if (this.selectedGkkp) {
                        const kgkpDataResponse = await fetch(
                            `/api-py/dict-kgkp-by-code/${this.selectedGkkp.code}`
                        );
                        const kgkpDataArray = await kgkpDataResponse.json();
                        const kgkpDataItem = kgkpDataArray.find(
                            (kgkp: IKgkp) => kgkp.bin === this.selectedGkkp.code
                        );

                        let guName = "";
                        if (kgkpDataItem && kgkpDataItem.code_gu) {
                            guName = await this.getGuName(kgkpDataItem.code_gu);
                        }
                        this.selectedKgkpGu = `${kgkpDataItem.code_gu} - ${guName}`;
                    }
                } else {
                    this.selectedRegionKgkp = null;
                }
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки место работы для: " + this.userId,
                    error.toString()
                );
            }
        }
    }

    private async loadReceiversList() {
        try {
            this.loading = true;
            let response: Response;

            if (!this.selectedGu && this.typeOrg === 0) {
                await this.getUserGuWork();
            }

            if (this.typeOrg === 0 && this.selectedGu) {
                response = await fetch(
                    `/api/um/users-list-gu?gu=${this.selectedGu.code}`
                );
            } else if (this.typeOrg === 1) {
                response = await fetch(
                    ` /api/um/users-list-kgkp?kgkp=${this.selectedGkkp.bin}`
                );
            } else {
                throw new Error("Некорректный тип организации");
            }

            if (!response) {
                throw new Error("Не удалось получить ответ от сервера");
            }

            const userData = await response.json();
            const processedData = userData.map((user: any) => {
                let iin = "";
                let firstNameCard = "";
                let middleName = "";
                let iinCard = "";
                const nameParts = user.firstname.split(" ");
                firstNameCard = nameParts[0];
                middleName = nameParts.slice(1).join(" ");
                if (user.username.startsWith("iin")) {
                    iin = user.username.substring(3);
                    iinCard = "ИИН" + " " + iin;
                } else {
                    iin = "Не определен";
                }
                return {
                    ...user,
                    iin: iin,
                    iinCard: iinCard,
                    patronymic: middleName,
                    firstNameCard: firstNameCard,
                };
            });
            this.usersList = processedData;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса списка пользователей",
                    error.toString()
                );
            }
        } finally {
            this.loading = false;
        }
    }

    private async changeData() {
        try {
            await this.loadReceiversList();
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка при получении списка пользоваталей",
                    error.toString()
                );
            }
        }
        this.$refs.drop.hide(true);
    }

    private resetFilterData() {
        if (this.typeOrg === 0) {
            if (this.selectedRegion) {
                this.selectedRegion = this.regionList[0];
                this.selectedGu = this.guList[0];
                this.loadReceiversList();
            } else {
                this.selectedGu = this.guList[0];
                this.loadReceiversList();
            }
        } else {
            if (this.selectedRegionKgkp) {
                this.selectedRegionKgkp = this.regionList[0];
                this.selectedGkkp = this.gkkpList[0];
                this.loadReceiversList();
            } else {
                this.selectedGkkp = this.gkkpList[0];
                this.loadReceiversList();
            }
        }
    }

    private openFilterByRef(refName: string) {
        const drop: any = this.$refs.drop;
        drop.show(true);
        let refItem: any;
        switch (refName) {
            case "bcRegGu":
                refItem = this.$refs.bcRegGu;
                break;
            case "bcRegion":
                refItem = this.$refs.bcRegion;
                break;
            case "bcRegionKgkp":
                refItem = this.$refs.bcRegionKgkp;
                break;
            case "bcGu":
                refItem = this.$refs.bcGu;
                break;
            case "bcGkkp":
                refItem = this.$refs.bcGkkp;
                break;
        }
        setTimeout(() => refItem.$el.focus(), 100);
    }

    get filteredUsersList(): IUsers[] {
        const searchFIO = this.searchName.toLowerCase().trim();
        const searchIIN = this.searchIIN.toLowerCase().trim();
        const searchPhone = this.searchPhone.toLowerCase().trim();
        const searchEmail = this.searchEmail.toLowerCase().trim();

        const searchFiltered = this.usersList.filter((user) => {
            const matchesFIO =
                user.lastname?.toLowerCase().includes(searchFIO) ||
                user.firstname?.toLowerCase().includes(searchFIO);

            const matchesIIN = user.iin
                ? user.iin.toLowerCase().includes(searchIIN)
                : searchIIN === "";

            const matchesEmail = user.email
                ? user.email.toLowerCase().includes(searchEmail)
                : searchEmail === "";

            return (
                matchesFIO &&
                // matchesPhone &&
                matchesIIN &&
                matchesEmail
            );
        });

        return searchFiltered;
    }

    private handleCheckboxChange() {}

    toggleSelectFiltered(): void {
        this.selectAllFiltered = !this.selectAllFiltered;
        this.filteredUsersList.forEach((user: IUsers) => {
            user.check = this.selectAllFiltered;
        });
        // this.updateSelectedReceiverIds();
    }

    private openUserCard(item: any) {
        this.selectedUser = item;
        const id = item.id;
        // this.$refs.userCardRef.hide(true);
        this.showUserCard = true;
        // this.getSelUserWork();
        this.getUserLevels();
        this.getUserModules();
        this.getModulesByCode();
        // this.getBaseModulesList();
    }

    private async getKGKPNameByCode(code: string) {
        const res = await fetch("/api-py/dict-kgkp-by-code/" + code);
        const data = await res.json();
        return data;
    }

    private async loadGuWorkPlaces(userId: string): Promise<IWorkPlace[]> {
        try {
            const response = await fetch(`/api-py/user-workplace/${userId}`);
            if (!response.ok) {
                throw new Error("Ошибка получения данных ГУ");
            }

            const guCodeData: { workplace: string }[] = await response.json();

            if (guCodeData.length === 0) return [];

            const guCodes = guCodeData.map((item) => item.workplace);
            const guPromises = guCodes.map((code: string) =>
                fetch(`/api-py/dict-gu-by-code/${code}`)
            );

            const guResults = await Promise.all(guPromises);
            const guData = await Promise.all(
                guResults.map((res) => res.json())
            );

            return guData.map((data) => ({
                code: data.code,
                text: `${data.code} - ${data.name_ru}`,
                type: "GU",
            }));
        } catch (error) {
            this.makeToast(
                "danger",
                "Ошибка загрузки ГУ",
                (error as Error).message
            );
            return [];
        }
    }

    private async loadKgkpWorkPlaces(userId: string): Promise<IWorkPlace[]> {
        try {
            const response = await fetch(
                `/api-py/user-workplace-kgkp/${userId}`
            );
            if (!response.ok) {
                throw new Error("Ошибка получения данных ГККП");
            }

            const kgkpData: { workplace: string }[] = await response.json();

            if (kgkpData.length === 0) return [];

            const kgkpCodes = kgkpData.map((item) => item.workplace);
            const kgkpPromises = kgkpCodes.map((code: string) =>
                this.getKGKPNameByCode(code)
            );

            const kgkpResults = await Promise.all(kgkpPromises);

            return kgkpResults.map((data) => ({
                code: data.bin || "",
                text: `${data.bin} - ${data.name_ru}`,
                type: "KGKP",
            }));
        } catch (error) {
            this.makeToast(
                "danger",
                "Ошибка загрузки ГККП",
                (error as Error).message
            );
            return [];
        }
    }

    private async loadAllWorkPlaces(): Promise<IWorkPlace[]> {
        if (!this.userId) {
            console.warn("User is not authorized");
            return [];
        }

        const [guList, kgkpList] = await Promise.all([
            this.loadGuWorkPlaces(this.userId),
            this.loadKgkpWorkPlaces(this.userId),
        ]);

        const all = [...guList, ...kgkpList];

        this.hasWorkPlace = all.length > 0;

        if (guList.length > 0 && kgkpList.length > 0) {
            this.workPlaceTypes = "Both";
        } else if (guList.length > 0) {
            this.workPlaceTypes = "GU";
        } else if (kgkpList.length > 0) {
            this.workPlaceTypes = "KGKP";
        } else {
            this.workPlaceTypes = null;
        }

        return all;
    }

    private async getUserLevels() {
        try {
            if (!this.selectedUser) {
                throw new Error("Пользователь не выбран!");
            }
            this.budgetLevelList = [];
            const response = await fetch(
                "/api-py/get-user-budget-level-only/" + this.selectedUser.id
            );
            const levels = await response.json();
            if (levels.includes("2")) {
                this.budgetLevelList.push("2-областной");
            }
            if (levels.includes("3")) {
                this.budgetLevelList.push("3-районный");
            }
            if (levels.includes("4")) {
                this.budgetLevelList.push("4-МСУ");
            }
            this.selBudgetLevel = this.budgetLevelList[0];
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса уровней бюджет пользователя",
                    error.message
                );
            }
        }
    }

    async getUserModules() {
        try {
            if (!this.selectedUser) {
                throw new Error("Пользователь не выбран!");
            }
            this.modulesList = [];
            const response = await fetch(
                "/api/um/module/links/" + this.selectedUser.id
            );
            const data = await response.json();

            this.modulesList = data
                .filter((item: any) => {
                    if (!item.modules || typeof item.modules !== "string") {
                        return false;
                    }

                    const codeParts = item.modules.split(".").map(Number);
                    const limitParts = "006.000".split(".").map(Number);

                    if (codeParts[0] < limitParts[0]) {
                        return true;
                    }
                    if (
                        codeParts[0] === limitParts[0] &&
                        codeParts[1] <= limitParts[1]
                    ) {
                        return true;
                    }
                    return false;
                })
                .map((item: any) => ({
                    code: item.modules,
                    name_ru: item.modules,
                    access_level: item.accessLevel,
                    operations: item.operations ? item.operations : [],
                }));

            this.modulesList.sort((a, b) => a.code.localeCompare(b.code));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса доступных модулей пользователя",
                    error.message
                );
            }
        }
    }

    private async getAllModules(): Promise<any[]> {
        try {
            const response = await fetch("/api-py/sic-modules");
            const data = await response.json();
            return data
                .filter(
                    (item: any) => item.code && typeof item.code === "string"
                )
                .sort((a: any, b: any) => a.code.localeCompare(b.code));

            // return data
            //     .filter((item: any) => {
            //         if (!item.code || typeof item.code !== "string") {
            //             return false;
            //         }

            //         const codeParts = item.code.split(".").map(Number);
            //         const limitParts = "006.000".split(".").map(Number);

            //         if (codeParts[0] < limitParts[0]) {
            //             return true;
            //         }
            //         if (
            //             codeParts[0] === limitParts[0] &&
            //             codeParts[1] <= limitParts[1]
            //         ) {
            //             return true;
            //         }
            //         return false;
            //     })
            // .sort((a: any, b: any) => a.code.localeCompare(b.code));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса списка модулей",
                    error.message
                );
            }
            return [];
        }
    }

    private async getModuleOperations(code: string): Promise<any[]> {
        try {
            const response = await fetch("/api-py/operations", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ code }),
            });

            const data = await response.json();
            return data;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса операции",
                    error.message
                );
            }
            return [];
        }
    }

    private async loadDictTypeApp(): Promise<any[]> {
        try {
            const response = await fetch("/api/dict/vw_order");
            const data = await response.json();
            return data;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса типов заявки",
                    error.toString()
                );
            }
            return [];
        }
    }

    private async loadDictTypeOrg(): Promise<any[]> {
        try {
            const response = await fetch("/api/dict/type_order");
            const data = await response.json();
            return data;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса видов предприятия",
                    error.toString()
                );
            }
            return [];
        }
    }

    private get getParModules(): IBaseModule[] {
        return this.modulesBase.filter((module: any) => module.par_id === 0);
    }

    private getChildModules(parentId: number) {
        return this.modulesBase.filter((module) => module.par_id === parentId);
    }

    private get filteredParModules() {
        return this.modulesBase
            .filter((module: any) => module.par_id === 0)
            .filter((parent: any) => {
                return this.modulesList.some(
                    (availableModule: any) =>
                        availableModule.code === parent.code
                );
            });

    }

    private getUsersChildModules(parentCode: string) {
        return this.modulesList.filter((module) => {
            return (
                module.code.startsWith(parentCode.substring(0, 3)) &&
                !module.code.endsWith(".000")
            );
        });
    }

    async getModulesByCode() {
        try {
            const response = await fetch("/api-py/sic-modules");
            const data = await response.json();

            this.modulesList.forEach((moduleFromFirstService) => {
                const foundModule = data.find(
                    (moduleFromSecondService: any) =>
                        moduleFromSecondService.code ===
                        moduleFromFirstService.code
                );

                if (foundModule && foundModule.name_ru) {
                    moduleFromFirstService.name_ru = foundModule.name_ru;
                }
            });
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса наименования модулей",
                    error.message
                );
            }
        }
    }

    isAgreeOper(operations: string[] | undefined): boolean {
        return (
            Array.isArray(operations) &&
            operations.some((op) => op.includes("agree"))
        );
    }

    isSignOper(operations: string[] | undefined): boolean {
        return (
            Array.isArray(operations) &&
            operations.some((op) => op.includes("sign"))
        );
    }

    private async backToUsersList() {
        this.backUsersList = true;
        this.showUserCard = false;
    } // back to Users List

    private async getCurUserInfo() {
        try {
            const response = await axios.get(
                `/api-py/get-realm-user/${this.userId}`
            );
            const data = response.data;
            this.currentUser = {
                ...data,
                fullName: `${data.firstName} ${data.lastName}`,
            };
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса информации о текущем пользователе",
                    error.message
                );
            }
        }
    }

    private mode: string = "view";

    onCreateNewRequest(payload?: { mode?: string }) {
        this.selectedRequest = null;
        this.mode = payload?.mode || "view";
    }

    private async downloadUserForm(lang: string) {
        if (!this.selectedRequest && this.mode !== "create") {
            this.makeToast(
                "warning",
                "Сначала выберите заявку для скачивания",
                "Выберите заявку"
            );
            return;
        }

        if (!this.selectedRequest && this.mode === "create") {
            this.makeToast(
                "warning",
                "Для скачивания формы сначала вам необходимо заполнить и сохранить заявку.",
                "Внимание!"
            );
            return;
        }

        this.makeToast(
            "info",
            "Скачанную форму необходимо согласовать с руководителем и заверить печатью организации.",
            "Внимание!"
        );

        const idOrder = this.selectedRequest.id;
        // const lang = this.$i18n.locale || "ru";

        try {
            const response = await axios.get(
                `/api/um/admin/mode/order/template-file`,
                {
                    params: {
                        idorder: idOrder,
                        lang: lang,
                    },
                    responseType: "blob",
                }
            );

            const contentDisposition = response.headers["content-disposition"];
            let fileName = "order_template.pdf";

            if (contentDisposition) {
                const matches =
                    contentDisposition.match(/filename="?([^"]+)"?/);
                if (matches && matches[1]) {
                    fileName = decodeURIComponent(matches[1]);
                }
            }

            const blob = new Blob([response.data], {
                type: "application/pdf",
            });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            this.makeToast(
                "danger",
                "Ошибка при загрузке файла",
                error instanceof Error ? error.message : String(error)
            );
        }
    }

    selectRequest(item: any) {
        this.selectedRequest = item;
    }

    private infoAdministration() {
        console.log("Инструкция скачалась!");
    } // download using info

    private triggerFileInput() {
        const input = this.$refs.fileInput.$el.querySelector("input");
        if (input) {
            input.click();
        }
    }

    private deleteCurFile() {
        this.file = null;
    }

    private removeUserInput(index: number) {
        this.newUserList.splice(index, 1);
    }

    private toggleDrown(index: number) {
        this.newUserList[index].isExpDropdown =
            !this.newUserList[index].isExpDropdown;
    }

    private toggleModuleDrown(index: number) {
        this.$set(
            this.getParModules[index],
            "isModuleDrown",
            !this.getParModules[index].isModuleDrown
        );
    }
    private toggleUsersModDrown(index: number) {
        this.$set(
            this.filteredParModules[index],
            "isUsersModuleDrown",
            !this.filteredParModules[index].isUsersModuleDrown
        );
    }

    private removeModule(index: number) {
        console.log("This module has deleted");
    }

    makeToast(variant: string | undefined, tostbody: any, title: string) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: "b-toaster-top-center",
            autoHideDelay: 2000,
            solid: true,
            appendToast: true,
        });
    }
}
